import Vue from 'vue'
import Vuex from 'vuex'
import tab from './tab'
import user from './user'
import bigDEals from './bigDEals'
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex)


export default new Vuex.Store({
 
  modules: {
    tab,//引入模块
    user,
    bigDEals,
    
  },
  plugins: [//持久化保存vuex数据
    createPersistedState()
  ],
})
